import { BloomFilterManager } from './BloomFilterManager';

module.exports = new BloomFilterManager('readFilter');



/** WEBPACK FOOTER **
 ** ./assets/js/readFilter.js
 **/